import { ClassValue } from 'clsx';
import { ScheduledAutomationField } from '@shared/data/entity/fields/ScheduledAutomationField';
import { DurationsTextView } from '@shared/scenes/entity/components/fields/ScheduledAutomationEditField';
import { CollectionViewFieldContainer } from './CollectionViewFieldContainer';
import { FieldVariant } from './FieldVariant';

interface Props {
  variant: FieldVariant;
  className?: ClassValue;
  field: ScheduledAutomationField;
}

/** Default and compact: the durations. Inline: the durations as text, in the host's size. */
export function ScheduledAutomationCollectionViewField({ field, variant, className }: Props) {
  return (
    <CollectionViewFieldContainer
      fieldType={field.fieldType}
      variant={variant}
      className={className}
    >
      {variant === 'inline' && field.toDisplayString()}
      {variant !== 'inline' && <DurationsTextView durations={field.durations} />}
    </CollectionViewFieldContainer>
  );
}
